/* Knopftext "Vorbestellen" beim Variantenwechsel nachziehen
 * (awork "Pickware vorbestellung", 02.11.2026).
 *
 * WOZU: Ob eine Variante vorbestellt wird, entscheidet allein Liquid
 * (snippets/lbrgt-verfuegbar-ab.liquid, zustand 'vorbestellung'). Der Kaufknopf
 * wird beim Variantenwechsel aber NICHT neu gerendert: assets/product-form.js
 * setzt in #updateButtonTextOptimistic nur den Text aus data-add-to-cart-text.
 * Ohne diese Datei bliebe nach einem Wechsel "Vorbestellen" auf einer Variante
 * mit Lagerbestand stehen - oder umgekehrt "In den Warenkorb" auf einer
 * Vorbestellung.
 *
 * WIE: Der Knopf traegt die IDs aller Vorbestell-Varianten des Produkts
 * (data-lbrgt-vb-ids) und beide Texte. Auf "variant:update" (assets/events.js)
 * wird je Knopf im selben Bereich nur verglichen und beschriftet. Gerechnet
 * wird hier nichts, deshalb kann die Anzeige nicht von der Regel abweichen.
 *
 * Der Listener haengt am document und laeuft damit NACH den Listenern des
 * Themes, die am Abschnitt haengen (product-form.js, sticky-add-to-cart.js).
 * Deren Text wird also ueberschrieben, nicht umgekehrt. Zusaetzlich wird
 * data-add-to-cart-text umgestellt, damit der naechste Theme-Durchlauf schon
 * den richtigen Text nimmt.
 *
 * Vorbild fuer den Aufbau: assets/lbrgt-lieferzeit-eigenschaft.js.
 */

(function () {
  if (window.lbrgtVorbestellungAktiv) return;
  window.lbrgtVorbestellungAktiv = true;

  function beschriften(knopf, varianteId, verfuegbar) {
    const ids = (knopf.dataset.lbrgtVbIds || "").split(",").filter(Boolean);
    const istVorbestellung = ids.indexOf(String(varianteId)) !== -1;
    const text = istVorbestellung ? knopf.dataset.lbrgtVbText : knopf.dataset.lbrgtStandardText;
    if (!text) return;

    knopf.dataset.addToCartText = text;

    // Gesperrter Knopf (ausverkauft/nicht verfuegbar): den Text des Themes
    // stehen lassen, der ist dann richtig.
    if (!verfuegbar) return;

    knopf
      .querySelectorAll(".add-to-cart-text__content, .btn__icon-text, [ref='addToCartText']")
      .forEach((ziel) => {
        ziel.textContent = text;
      });
    if (knopf.hasAttribute("aria-label")) knopf.setAttribute("aria-label", text);
  }

  document.addEventListener("variant:update", (event) => {
    const variante = event.detail && event.detail.resource;
    if (!variante || !variante.id) return;

    // Nur Knoepfe im selben Bereich wie das ausloesende Element anfassen
    // (Produktseite, Schnellkauf-Dialog, Produktkarte).
    const bereich =
      event.target && event.target.closest
        ? event.target.closest(".shopify-section, dialog, product-card")
        : null;
    const wurzel = bereich || document;

    wurzel.querySelectorAll("[data-lbrgt-vb-ids]").forEach((knopf) => {
      beschriften(knopf, variante.id, variante.available);
    });
  });
})();
